export enum CustomerProfileEnum {
  AdhesionCard = 'adhesion_card',
  Pilot = 'pilot',
  AdhesionB2c = 'adhesion_b2c',
  OutboundCustomer = 'outbound_customer',
  SaasCustomer = 'saas_customer',
  Partner = 'partner',
  Trial = 'trial',
  AdhesionSheet = 'adhesion_sheet',
  Association = 'association',
}

